export default __webpack_public_path__ + "static/media/1686.8c96e271.png";